module.exports = __webpack_public_path__ + "webpc/img/icon_ing.10a11514.png";